<template>
  <!-- Item của combo không có column -->
  <li
    v-if="comboType === ComboType.Normal"
    class="combobox-item single"
    :class="{ parent: item.isParent }"
    :style="'text-align: ' + align"
  >
    <div
      v-if="isCheckMultiple"
      class="cell-checkbox mr-2"
    >
      <div
        class="icon"
        :class="{ checked: isSelected }"
      />
    </div>

    <div class="combobox-item-con">
      <div
        class="combobox-item--text"
        :title="getItemDisplay(item)"
      >
        {{ getItemDisplay(item) }}
      </div>
    </div>
  </li>
  <li
    v-else-if="comboType === ComboType.Tree && columnx.length == 0"
    class="combobox-item single"
    :class="{ parent: item.isParent }"
    :style="'text-align: ' + align"
    v-on="listeners"
  >
    <div class="combobox-item-con">
      <div
        v-if="isCheckMultiple"
        class="cell-checkbox mr-2"
      >
        <div
          class="icon"
          :class="{ checked: isSelected }"
        />
      </div>
      <div
        class="combobox-item--text"
        :class="`level-${item.level}`"
        :title="getItemDisplay(item)"
      >
        {{ getItemDisplay(item) }}
      </div>
    </div>
  </li>
  <tr
    v-else
    class="combobox-item"
    :class="{ parent: item.isParent }"
  >
    <!-- Item của combo có column -->
    <td v-if="isCheckMultiple">
      <div class="cell-checkbox-combobox">
        <div
          class="icon"
          :class="{ checked: isSelected }"
        />
      </div>
    </td>
    <td
      v-for="(column, colIndex) in columnx"
      :ref="`td-${colIndex}`"
      :key="column.dataField"
      class="combobox-item-td"
      :class="comboType === ComboType.Tree && colIndex === 0 ? `level-${item.level}` : null"
    >
      <div
        class="combobox-item-td--contents"
        :style="getCellStyle(column, colIndex)"
      >
        <div
          :title="getItemDisplay(item, column)"
          class="combobox-item-td--text"
        >
          {{ getItemDisplay(item, column) }}
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { defineComponent, getCurrentInstance } from 'vue'

import { ComboType } from './constants'

export default defineComponent({
  name: 'MsComboBoxItem',
  props: {
    /**
     * Loại combo
     */
    comboType: {
      type: Number,
      default: ComboType.Normal,
    },
    /**
     * Item sử dụng để binding
     */
    item: {
      type: Object,
      default: () => {},
    },
    /**
     * Cấu hình cột của menu
     */
    columnx: {
      type: Array,
      default: () => [],
    },
    /**
     * Trường làm value
     */
    valueField: {
      type: String,
      default: null,
    },
    /**
     * Trường là display
     */
    displayField: {
      type: String,
      default: null,
    },
    /**
     * Kiểu định dạng dữ liệu trên combobox
     * Tương ứng với FormatType
     */
    formatType: {
      type: [Number, String],
      default: null,
    },
    /**
     * style text align
     */
    align: {
      type: String,
      default: 'left',
    },
    /**
     * có check box không
     */
    isCheckMultiple: {
      type: Boolean,
      default: false,
    },
    /** Có phải là bản ghi được chọn hay không */
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['removeItem'],
  setup (props) {
    // Variable
    const { proxy } = getCurrentInstance()

    // Method
    /**
     * Hàm lấy style cho td trong table
     * dữ liệu động theo config của dev
     */
    const getCellStyle = (column, index) => {
      if (column.isResize) {
        if (
          proxy.$refs[`td-${index}`] &&
          proxy.$refs[`td-${index}`].length > 0
        ) {
          const item = proxy.$refs[`td-${index}`][0]
          const rectTd = item.getBoundingClientRect()
          const rectParent = proxy.$parent.$el.getBoundingClientRect()
          if (rectTd.right <= rectParent.right) {
            return {
              width: rectTd.width + (rectParent.right - rectTd.right) + 'px',
              textAlign: column.columnAlign,
            }
          } else {
            return {
              width: `${column.width}px`,
              textAlign: column.columnAlign,
            }
          }
        }
      }
      return {
        width: column.isResize ? null : `${column.width}px`,
        textAlign: column.columnAlign,
      }
    }

    /**
     * Lấy text hiển thị trên item
     * Nếu có column lấy theo column.field, nếu không có column lấy theo displayField, nếu không có displayField lấy theo valueField
     * CreatedBy PDKIEN 10/12/2019
     * NNLINH 05.07.2022 Add FormatTypeColumn
     */
    const getItemDisplay = (item, column) => {
      const field = column
        ? column.dataField
        : props.displayField || props.valueField

      let value = field
        ? item[field]
        : item

      if (column && column.formatType) {
        switch (column.formatType) {
          case proxy.$ms.constant.FormatType.Date:
          case proxy.$ms.constant.FormatType.Enum:
            if (value) {
              value = proxy.$ms.format.formatData(value, {
                formatType: column.formatType,
                enumName: column.enum, // truyền thừa giá trị này ko sao
              })
            }
            break
        }
      }
      return value
    }

    return {
      getCellStyle,
      getItemDisplay,
      ComboType,
    }
  },
})
</script>

<style lang="scss">
@import '@/assets/scss/components/MsComboboxItem.scss';
</style>
